import { useState } from "react";
import { IPortInInformation, PortInState } from "../interface/IPortIn";
import { getPortinRoute } from "@api-routes";
import { getResponseToState } from "../mappers/getPortInDetailsMapper";
import { useFetch } from "@common/hook/useFetch";

export const useGetPortIn = () => {
    const [previousPhoneNumber, setPreviousPhoneNumber] = useState("");
    const [isPortOpen, setIsPortOpen] = useState(false);
    const [portInDetails, setPortInDetails] = useState<IPortInInformation>();

    const [getPortInState, { get }] = useFetch();

    const castEnum = (state: string): PortInState => {
        switch (state) {
            case PortInState[PortInState.INITIAL]:
                return PortInState.INITIAL;
            case PortInState[PortInState.SCHEDULED]:
                return PortInState.SCHEDULED;
            case PortInState[PortInState.IN_PROGRESS]:
                return PortInState.IN_PROGRESS;
            case PortInState[PortInState.COMPLETED]:
                return PortInState.COMPLETED;
            default:
                return PortInState.INITIAL;
        }
    };

    const getPortIn = (serviceId: number) => {
        get<IPortInInformation>(getPortinRoute(serviceId)).then((portInResponse) => {
            if (portInResponse) {
                const portInMapped = getResponseToState(portInResponse);

                if (portInMapped.state !== PortInState[PortInState.INITIAL]) {
                    setPortInDetails(portInMapped);
                    setPreviousPhoneNumber(portInMapped.phoneNumber);
                } else {
                    setPreviousPhoneNumber("");
                }
            } else {
                setPreviousPhoneNumber("");
            }
        });
    };

    const portInState = portInDetails ? castEnum(portInDetails.state) : PortInState.INITIAL;

    return {
        getPortIn,
        getPortInState,
        isPortOpen,
        portInState,
        previousPhoneNumber,
        setIsPortOpen,
        portInDetails,
    };
};
